const peopleCountRe = "^[0-9]*$";
export { peopleCountRe };
